import { Center, Group, Pagination, Paper, Stack, Title } from "@mantine/core"
import { useDisclosure, usePagination } from "@mantine/hooks"
import { InformationRequestStatus } from "@tfg/db"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { FindCertificateRequestsForSupplierResponseDto } from "~/gen/api"
import { TransferCertificateRequestModal } from "~/pages/SupplierPortal/TraceabilityRequests/Modals/TransferCertificateRequestModal.tsx"
import { CertificateRequestsBatchModal } from "~/pages/SupplierPortal/TraceabilityRequests/Modals/certificateRequestsBatchModal/CertificateRequestsBatchModal"
import { CertificateRequest } from "~/pages/SupplierPortal/TraceabilityRequests/components/CertificateRequest"

interface Props {
  closedRequests: FindCertificateRequestsForSupplierResponseDto[]
  openedRequests: FindCertificateRequestsForSupplierResponseDto[]
  status: InformationRequestStatus
}
const REQUESTS_PER_PAGE = 10

export const CertificateRequests = ({
  closedRequests,
  openedRequests,
  status,
}: Props) => {
  const { t } = useTranslation(["traceability"])
  const filteredCertificateRequests =
    status === "OPENED" ? openedRequests : closedRequests

  const pagination = usePagination({
    total: Math.ceil(filteredCertificateRequests.length / REQUESTS_PER_PAGE),
  })

  const [transferCertificateRequestId, setTransferCertificateRequestId] =
    useState<string>()
  const [
    openedTransferModal,
    { open: openTransferModal, close: closeTransferModal },
  ] = useDisclosure(false)

  return (
    <Stack>
      <Group justify="right">
        <Pagination
          size="sm"
          value={pagination.active}
          onChange={pagination.setPage}
          total={Math.ceil(
            filteredCertificateRequests.length / REQUESTS_PER_PAGE
          )}
        />
      </Group>
      {filteredCertificateRequests.length === 0 ? (
        <Center pt="xl">
          <Title order={3}>{t("certificates.noRequests")}</Title>
        </Center>
      ) : (
        <Stack>
          {filteredCertificateRequests
            ?.slice(
              (pagination.active - 1) * REQUESTS_PER_PAGE,
              pagination.active * REQUESTS_PER_PAGE
            )
            .map((request) => (
              <Paper p="md" key={request.id}>
                <CertificateRequest
                  certificateRequest={request}
                  setTransferCertificateRequestId={
                    setTransferCertificateRequestId
                  }
                  openTransferModal={openTransferModal}
                />
              </Paper>
            ))}
        </Stack>
      )}
      <TransferCertificateRequestModal
        opened={openedTransferModal}
        close={() => {
          closeTransferModal()
          setTransferCertificateRequestId(undefined)
        }}
        certificateRequestId={transferCertificateRequestId}
      />
      <CertificateRequestsBatchModal />
    </Stack>
  )
}
